/*global JSONstat:false */
const config = require ('../../../configs/configuration.js')
const constants = config.configuration.data;

import { storage } from './storage';
import JSONstat from 'jsonstat';
import extractData from './extracts/extract';
import {removeParam} from './components/utils'

var indicators;

function queryService(category) {
    indicators = window.indicators;
    'use strict';

    const environment = storage.NODE_ENV;

    //create the countries
    const countries = constants.countries;

    var countries2remove = indicators[category].countries2Remove;
    for (var country2remove of countries2remove) {
        var index = countries.indexOf(country2remove);
        if (index > -1) {
            countries.splice(index, 1);
        }
    }
    let countriesUrl = '';
    for (var country of countries) {
        countriesUrl += `&geo=${country}`;
    }

    //retrieve correct webservice endpoint depending on environment
    const jsonURL = constants[`url_${environment}`];


    //create time

    const timeIndicators = indicators[category].periods;
    let timeUrl = '';
    for (var time of timeIndicators) {
        timeUrl += `&time=${time}`;
    }

    //create parameters which need to be added to request
    let paramUrl = '?';
    const paramIndicator = indicators[category];
    const params = paramIndicator.params;

    for (var key in params) {  
        var valuesArr = params[key];
        if (valuesArr["selected"]) {
            valuesArr = [valuesArr.selected];
            /*valuesArr = $.map( valuesArr.items, function( val, i ) {
                return val.code;
              });*/
        }
        for (var value of valuesArr) {
                paramUrl += `${key}=${value}&`;
        }
    }
    paramUrl = paramUrl.slice(0, paramUrl.length -1 );

    //assemble URL
    let url; // = jsonURL + constants.lang + '/' + constants.dataUrls[category] + countriesUrl + timeUrl;
    if (environment !== 'local' && environment !== 'dev_serve') {
        url = jsonURL + indicators[category].table + paramUrl + countriesUrl + timeUrl;
        //url = jsonURL + constants.lang + '/'+"sbs_sc_sca_r2?nace_r2=B-N_S95_X_K&precision=1&size_emp=0-9&size_emp=10-19&size_emp=20-49&size_emp=50-249&size_emp=GE250&size_emp=TOTAL&indic_sb=V11110";
        if (paramUrl.includes("precision")) {
            url = removeParam("precision", url);
            url+= constants["url_settings"];
        }else {
            
        }

    } else {
        const pos = constants.dataUrls[category].indexOf('?');
        let datasetName;

        if (pos !== -1) {
            datasetName = constants.dataUrls[category].substr(0, pos);
        } else {
            datasetName = constants.dataUrls[category];
        }

        url = jsonURL + datasetName + '.json';
    }


    return jQuery.ajax({
        type: 'GET',
        url: url,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        crossDomain: true,
        cache: true,
        timeout: 30000,
        processData: false,
        data: ''
    }).done(function (data) {
        storage.rawData[category] = data;
    }).fail(function (jqXHR, textStatus, errorThrown) {console.log("error WS");
        jQuery('#graph-container').empty();
        jQuery('#graph-container').append('<div style=\'text-align: center; vertical-align: middle;\'>There was an error retrieving data.<br />Please try again in a few minutes.</div>');
        jQuery('#graph-container').text('There was an error retrieving data. Please try again in a few minutes.');
        jQuery('#loader').hide();
    });
}


function assembleData(category) {
    'use strict';

    // let paramObj = constants.paramObj[category],
    const paramIndicator = indicators[category];
    const params = paramIndicator.params;

    let paramObj = {}, 
        data = [],
        countries = constants.countries;
        var countries2remove = indicators[category].countries2Remove;
        for (var country2remove of countries2remove) {
            var index = countries.indexOf(country2remove);
            if (index > -1) {
                countries.splice(index, 1);
            }
        }

        const jsonStat = JSONstat(storage.rawData[category]);
        const jsonData = jsonStat.Dataset(0);

        //fill paramObj
        for (var key in params) {        
            const valuesArr = params[key];
            if (valuesArr["selected"]) {
                 valuesArr = [valuesArr.selected];
            }
    
            for (var value of valuesArr) {      
                paramObj[key] = value;
            }
        }
        paramObj.dataset = paramIndicator.table;
        data = extractData(countries, jsonData, paramObj, category, paramIndicator.params.size_emp);

    return data;

}


export default function requestData(category) {
    'use strict';

    if (storage.processedData[category]){
        return storage.processedData[category];
    } else {
            // Array of requests
    let requests = [];

    requests.push(queryService(category));


    let defer = $.when.apply($, requests);
    return defer.done(function () {

        // This is executed only after all ajax request have been completed
        // for (const [index, para] of Array.from(constants.paramObj).entries()) {
        //     storage.processedData[index] = assembleData(index);
        // }
        storage.processedData[category] = assembleData(category);
    });
    }


}